var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ELSWithModalService } from '@els/els-component-modal-react';
import DemoInit from 'components/demo-init/DemoInit';
import { routerSelectors } from 'redux/ducks/route';
import { getAdobeProductCode } from 'helpers/app.helper';
import { appSelectors } from 'redux/ducks/app';
import { ELSTokenHelper } from '..';
var pathname = 'pathname';
var LocationChangeHandler = /** @class */ (function (_super) {
    __extends(LocationChangeHandler, _super);
    function LocationChangeHandler() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.updateAdobeProductCodeByLocation = function () {
            var _a, _b, _c, _d;
            var adobeProductCode = getAdobeProductCode(_this.props.location[pathname]);
            if (((_b = (_a = window === null || window === void 0 ? void 0 : window.pageData) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.productName) !== adobeProductCode) {
                window.pageData = __assign(__assign({}, window.pageData), { page: __assign(__assign({}, (_c = window.pageData) === null || _c === void 0 ? void 0 : _c.page), { productName: adobeProductCode }) });
            }
            window.pageData = __assign(__assign({}, window.pageData), { visitor: __assign(__assign({}, (_d = window.pageData) === null || _d === void 0 ? void 0 : _d.visitor), { details: _this.userRole }) });
        };
        return _this;
    }
    LocationChangeHandler.prototype.componentDidMount = function () {
        this.updateAdobeProductCodeByLocation();
    };
    LocationChangeHandler.prototype.componentDidUpdate = function (_a) {
        var location = _a.location;
        if (location && this.props.location && location[pathname] !== this.props.location[pathname]) {
            this.props.modalService.closeAllModal();
            this.updateAdobeProductCodeByLocation();
        }
        /* eslint-disable no-underscore-dangle */
        window._mfq = window._mfq || [];
        var regexp = new RegExp('/#', 'g');
        var href = window.location.href.replace(regexp, '');
        window._mfq.push(['newPageView', href]);
    };
    Object.defineProperty(LocationChangeHandler.prototype, "userRole", {
        get: function () {
            var role = this.props.role;
            var token = ELSTokenHelper === null || ELSTokenHelper === void 0 ? void 0 : ELSTokenHelper.getToken();
            if (token) {
                var tokenData = ELSTokenHelper === null || ELSTokenHelper === void 0 ? void 0 : ELSTokenHelper.parseToken(token);
                role = role !== null && role !== void 0 ? role : tokenData === null || tokenData === void 0 ? void 0 : tokenData.role;
            }
            return role;
        },
        enumerable: false,
        configurable: true
    });
    LocationChangeHandler.prototype.render = function () {
        return <DemoInit />;
    };
    return LocationChangeHandler;
}(Component));
var mapStateToProps = createStructuredSelector({
    location: routerSelectors.getLocation,
    role: appSelectors.getUserRole
});
export default connect(mapStateToProps)(ELSWithModalService(LocationChangeHandler));
